const RNW = require("react-native-web/dist/index.js");

const dummyNativeModule = new Proxy({}, {
    get(target, prop) {
        if (typeof prop === "symbol" || prop === "$$typeof" || prop === "default" || prop === "__esModule" || prop === "name" || prop === "prototype") {
            return undefined;
        }
        if (prop === "getConstants") return () => ({});
        return () => new Promise((resolve) => resolve());
    }
});

const NativeModulesProxy = new Proxy(RNW.NativeModules || {}, {
    get(target, prop) {
        if (prop in target) return target[prop];
        if (typeof prop === "symbol" || prop === "$$typeof" || prop === "default" || prop === "__esModule" || prop === "name") {
            return undefined;
        }
        return dummyNativeModule;
    }
});

const TurboModuleRegistry = {
    get: () => dummyNativeModule,
    getEnforcing: () => dummyNativeModule
};

module.exports = {
    ...RNW,
    NativeModules: NativeModulesProxy,
    TurboModuleRegistry
};
